import React from 'react';
import { HStack, Box, Divider, Text, Icon } from '@chakra-ui/react';
import { IoCheckmarkOutline } from 'react-icons/io5';

type Props = { steps: string[]; activeStep: number; nextStep: () => void; previousStep: () => void };

const StepperRentals = ({ steps, activeStep }: Props): JSX.Element => {
  const totalSteps = steps.length;
  return (
    <HStack gap={0} width={'100%'} pt={2} pb={'30px'} justifyContent={'center'} px={4}>
      {steps.map((ele, index) => (
        <React.Fragment key={index}>
          <Box>
            <Box
              width="24px"
              height="24px"
              borderRadius="50%"
              border="2px solid"
              borderColor={'#54D8AD'}
              bg={index <= activeStep ? 'rentals.states.approved' : 'transparent'}
              color={index === activeStep ? 'white' : 'blue.500'}
              display="flex"
              alignItems="center"
              justifyContent="center"
              position={'relative'}
            >
              {index <= activeStep && <Icon as={IoCheckmarkOutline} color={'White'} />}
              <Text position={'absolute'} bottom={'-40px'} textAlign={'center'} fontSize={'0.75rem'} width="80px">
                {ele}
              </Text>
            </Box>
          </Box>

          {index < totalSteps - 1 && (
            <Divider
              orientation="horizontal"
              border="1px solid"
              borderColor={'#54D8AD'}
              width={['70px', '70px', '50px', '60px', '70px']}
            />
          )}
        </React.Fragment>
      ))}
    </HStack>
  );
};

export default StepperRentals;
